__turbopack_context__.v({
  "headerBar": "Jf2_vq_headerBar",
  "tabPanel": "Jf2_vq_tabPanel",
  "tabsInset": "Jf2_vq_tabsInset",
});
